import { FetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useSubscription } from 'react-apollo';

export const useDeleteDocumentNotificationSubscription = (fetchPolicy?: FetchPolicy) => {
    const { data, error, loading } = useSubscription<DeleteDocumentNotificationSubscriptionData>(DeleteDocumentNotificationSubscription, {
        fetchPolicy: fetchPolicy
    });

    return {
        data,
        error,
        loading,
    };
};

export interface DeleteDocumentNotificationSubscriptionData {
    deleteDocumentNotification: DeleteDocumentNotification;
}

export interface DeleteDocumentNotification {
    id:                number;
    description: string;
    message:           string;
    status:            boolean;
}

export const DeleteDocumentNotificationSubscription = gql`
    subscription DeleteDocumentSubcription{
        deleteDocumentNotification {
            id
            description
            message
            status
        }
    }
`;